import { Router } from 'vue-router';

export const redirectToDetails = (router: Router, id: string | number, targetRouteName: string): void => {
  let routeName = targetRouteName;
  const mainRouteName = targetRouteName.split('.')[0] ?? routeName;
  const currentName = router.currentRoute.value.name?.toString();

  // If you're already on a specific sub-route (tab) *within the target section* and click
  // another item in the table, open that same tab for the new item. Only reuse the current
  // route when it belongs to the target section — otherwise a cross-section click (e.g. the
  // charging-station logging tab linking to a message) would push the wrong route with a
  // foreign id.
  if (currentName && currentName.startsWith(`${mainRouteName}.`)) {
    routeName = currentName;
  }

  router.push({
    name: routeName,
    params: { id },
    // keep the list page's search/filter query params while the detail is open
    query: router.currentRoute.value.query
  });
};
